/**
 * DWEB-206 — the service-area sentence. One home, two readers:
 *
 *   src/components/Footer.js         renders it under the address
 *   scripts/prerenderContent.mjs     writes it into the static block
 *
 * WHY THE SECOND READER. The footer's visible text is not in the crawlable
 * layer: the prerendered block is the hero, the services and the DWEB-186 nav,
 * and it carries no footer, no address and no city name. A line that needs
 * React to render is a line a non-rendering crawler never receives.
 *
 * The wording is owner-approved copy (2026-09-13). It is a SENTENCE on purpose:
 * a bare comma-separated run of city names under an address is the
 * keyword-stuffing shape. The cities it names are held equal to the areaServed
 * declaration in public/index.html by e2e/entity-graph.spec.js, so the two
 * cannot drift apart.
 *
 * Expected search effect: none worth claiming. It is site-wide footer copy, and
 * the local channel is a Business Profile the published address cannot have
 * (DWEB-207). It ships because it is true and useful to a reader.
 *
 * Import-free, because importConfig loads it from plain node and refuses a
 * module with an import.
 */
export const SERVICE_AREA_LINE =
  'Working with clients across Los Angeles, Pasadena, Alhambra, Irvine and San Diego — and remotely, worldwide.';
